/** A desk's request type, as either name for it can arrive. */
export interface RequestTypeName {
  key: string;
  label: string;
}

/**
 * Whether two request-type values name the same type.
 *
 * KEY OR LABEL, EITHER SIDE. A ticket stores its type as the label, which is
 * what intake writes; a policy or a field is scoped by whatever the editor
 * saved, which has been the key on one desk and the label on another. They
 * were compared as strings, so a policy scoped by key never applied to any
 * ticket -- every security report ran on the default SLA.
 */
export function sameRequestType(
  a: string | null,
  b: string | null,
  types: readonly RequestTypeName[] = [],
): boolean {
  if (a === null || b === null) return false;
  if (a === b) return true;
  const keyOf = (v: string) => types.find((t) => t.key === v || t.label === v)?.key ?? v;
  return keyOf(a) === keyOf(b);
}
